import { render, staticRenderFns } from "./waitTransport.vue?vue&type=template&id=673c07e3&scoped=true"
import script from "./waitTransport.vue?vue&type=script&lang=js"
export * from "./waitTransport.vue?vue&type=script&lang=js"
import style0 from "./waitTransport.vue?vue&type=style&index=0&id=673c07e3&prod&scoped=true&lang=scss"
import style1 from "./waitTransport.vue?vue&type=style&index=1&id=673c07e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673c07e3",
  null
  
)

export default component.exports